import { useEffect, useState } from "react";

import { AssessmentInsightsHttpService } from "@/modules/assessments/services/assessment-insights-http.service";
import { AssessmentInsightsData } from "@/modules/assessments/types/insights.interface";
import { isValidNumericParam } from "@/shared/utils/common.utils";

export function useAssessmentInsights(assessmentId: number | undefined, startDate?: string, endDate?: string) {
  const [data, setData] = useState<AssessmentInsightsData | undefined>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | undefined>();

  useEffect(() => {
    if (!isValidNumericParam(assessmentId)) {
      setIsLoading(false);
      return;
    }

    let cancelled = false;

    const fetchInsights = async () => {
      try {
        setIsLoading(true);
        setError(undefined);
        const insights = await AssessmentInsightsHttpService.getAssessmentInsights(
          Number(assessmentId),
          startDate,
          endDate,
        );
        if (!cancelled) {
          setData(insights);
        }
      } catch (e) {
        if (!cancelled) {
          console.error(`Get assessment insights error: ${e}`);
          setError("Failed to load assessment insights.");
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    fetchInsights();

    return () => {
      cancelled = true;
    };
  }, [assessmentId, startDate, endDate]);

  return { data, isLoading, error };
}
